export class CookieConsent {
  private readonly _element: JQuery<HTMLElement>;

  constructor(element: JQuery<HTMLElement>) {
    this._element = element;

    const button = this._element.find('button');
    const cookieString = button.data('cookie-string');

    button.on('click', () => {
      document.cookie = cookieString;
      this._element.hide();
    });
  }
}
